import React, { useMemo } from 'react';
import { PSA_CONSTANTS } from '@nile/components/src/Constants/PSA';

export function useSitewiseSplit({ data, invoiceSettings, isCreate = false }) {
  const isSiteWiseSplitEnabled = useMemo(() => {
    if (invoiceSettings?.invoiceTemplate?.preferences) {
      return (
        invoiceSettings.invoiceTemplate.preferences.groupBy ===
        PSA_CONSTANTS.GROUP_BY.SITE
      );
    }

    return false;
  }, [invoiceSettings]);

  const dataGroupedBySite = useMemo(() => {
    const itemsGroupedBySiteId = {};

    if (!isSiteWiseSplitEnabled) return {};
    // eslint-disable-next-line no-unused-expressions
    data?.items?.forEach((item) => {
      /*
       * item.offeredItem.site -  For items from `getInvoice` response
       * item.site - For items from `constructInvoiceItems` response
       * data.billTo - To group items under selected site in invoice
       */
      const site = isCreate
        ? item?.site
        : item?.offeredItem?.site || item?.site;

      const { id, name } = site || {
        id: data.billTo?.id,
        name: data.billTo?.name
      };
      if (!itemsGroupedBySiteId[id]) {
        itemsGroupedBySiteId[id] = { items: [item], siteName: name };
      } else {
        itemsGroupedBySiteId[id].items.push(item);
      }
    });
    return itemsGroupedBySiteId;
  }, [data, isSiteWiseSplitEnabled]);

  return { isSiteWiseSplitEnabled, dataGroupedBySite };
}
